<template>
    <v-overlay>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>

<script>
    export default {
        name: "PinSwitch",
        mounted() {
            if (this.$pinSwitchService.get()) {
                this.$pinSwitchService.remove();
            } else {
                this.$pinSwitchService.set();
            }
            this.$router.replace({
                name: 'home'
            });
        }
    }
</script>

<style scoped>

</style>